import _Space from './Space';

import './style/index.js';

export type { SpaceProps } from './Space';
export * from './type';

export const Space = _Space;
export default Space;
